import React from 'react';

const TemplateSelector = ({ 
  value, 
  onChange, 
  availableScripts = {}, 
  label = 'Select Template',
  className = '',
  disabled = false
}) => {
  return (
    <div className={className}>
      {label && <h4 className="font-medium text-gray-700 mb-3">{label}</h4>}
      <select
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
                
        {Object.entries(availableScripts)
          .filter(([id]) => id !== 'default')
          .map(([id, script]) => (
            <option key={id} value={id}>
              {script.name}
            </option>
          ))}
      </select>
    </div>
  );
};

export default TemplateSelector;

